import { deleteApp, initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged as fbOnAuthStateChanged,
  getIdToken,
  User,
} from "firebase/auth";

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyAUA7prv6cNtwi-ESjOpnEisa8IUrAZQSk",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "srama-58508.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "srama-58508",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "srama-58508.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "915190955758",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch(() => {});

export const firebaseAuth = auth;

export const firebaseSignIn = (email: string, password: string) =>
  signInWithEmailAndPassword(auth, email, password);

export const firebaseSignOut = () => signOut(auth);

export const getFirebaseIdToken = async (
  forceRefresh = false
): Promise<string | null> => {
  const user = auth.currentUser;
  if (!user) return null;
  return getIdToken(user, forceRefresh);
};

export const getCurrentFirebaseUser = (): User | null => auth.currentUser;

export const onFirebaseAuthStateChanged = (
  cb: (user: User | null) => void
) => fbOnAuthStateChanged(auth, cb);

// Creates a new Firebase user without affecting the current admin's session.
// `createUserWithEmailAndPassword` on the default app would sign the new user
// in and bump the current admin out. Using a throwaway secondary app keeps
// the admin's session intact.
export const createFirebaseUserAsSuperAdmin = async (
  email: string,
  password: string
): Promise<{ uid: string }> => {
  const secondary = initializeApp(firebaseConfig, `staff-create-${Date.now()}`);
  try {
    const secondaryAuth = getAuth(secondary);
    const cred = await createUserWithEmailAndPassword(
      secondaryAuth,
      email,
      password
    );
    await signOut(secondaryAuth).catch(() => {});
    return { uid: cred.user.uid };
  } finally {
    await deleteApp(secondary).catch(() => {});
  }
};
